import * as yup from 'yup';

export const formSchema = yup.object().shape({
  address: yup.string(),
  email: yup.string().email('El email no es válido.'),
  openingHours: yup.string(),
  phoneNumber: yup.string().max(20, 'Máximo 20 caracteres'),
  whatsapp: yup.string().max(20, 'Máximo 20 caracteres'),
  name: yup
    .string()
    .min(5, 'Mínimo 5 caracteres')
    .max(100, 'Máximo 100 caracteres')
});
